import { Injectable } from '@angular/core';
import { Observable, shareReplay } from 'rxjs';

// Short-lived cache for reference lists that pages load over and over
// (categories, attributes, labels, the product list...) - e.g. every time a
// product is opened for editing. Cleared after any successful change made
// through the back office (see AuthInterceptor), so an edit elsewhere shows
// up straight away rather than after the TTL.
@Injectable({ providedIn: 'root' })
export class RefDataCacheService {
  private entries = new Map<string, { at: number; data$: Observable<unknown> }>();

  get<T>(key: string, load: () => Observable<T>, ttlMs = 5 * 60 * 1000): Observable<T> {
    const hit = this.entries.get(key);
    if (hit && Date.now() - hit.at < ttlMs) return hit.data$ as Observable<T>;
    const data$ = load().pipe(shareReplay({ bufferSize: 1, refCount: false }));
    this.entries.set(key, { at: Date.now(), data$ });
    // A failed load isn't kept - the next caller tries again.
    data$.subscribe({ error: () => this.entries.delete(key) });
    return data$;
  }

  clear(): void {
    this.entries.clear();
  }
}
